import { Text, View } from '@react-pdf/renderer';

import { commonStyles } from 'src/common/pdf/common.styles';
import { currencyFormatter } from 'src/features/billing/invoices/forms/cells/utils';
import { styles } from 'src/features/billing/invoices/pdf/styles';
import { InvoicePaymentRow } from 'src/features/billing/invoices/types';

import { ExpandedPaymentsTable } from './ExpandedPaymentsTable';

interface ExpandedPaymentsLineProps {
  paymentAmount: number;
  payments: Array<InvoicePaymentRow>;
}
export function ExpandedPaymentsLine({
  paymentAmount,
  payments,
}: ExpandedPaymentsLineProps) {
  return (
    <>
      <View
        style={[
          styles.subTotalStyle,
          { flexDirection: 'column', justifyContent: 'flex-start' },
        ]}
      >
        <Text style={commonStyles.strong}>Payments</Text>
        <ExpandedPaymentsTable data={payments} />
      </View>
      <View style={[styles.subTotalStyle]}>
        <Text style={commonStyles.strong}>Total Payments</Text>
        <Text>{currencyFormatter(paymentAmount)}</Text>
      </View>
    </>
  );
}
